(function () {
  function destroy(root) {
    if (!root) return;
    if (typeof root._siGridClickCleanup === 'function') {
      root._siGridClickCleanup();
      root._siGridClickCleanup = null;
    }
    if (root._siEmblaApi) {
      root._siEmblaApi.destroy();
      root._siEmblaApi = null;
    }
    root.removeAttribute('data-signage-industry-initialized');
  }

  function setActiveIndex(root, index) {
    var cells = root.querySelectorAll('[data-si-grid-index]');
    cells.forEach(function (cell, i) {
      var on = i === index;
      cell.classList.toggle('is-selected', on);
      cell.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var bodies = root.querySelectorAll('[data-si-body]');
    bodies.forEach(function (body, i) {
      body.classList.toggle('is-active', i === index);
      body.hidden = i !== index;
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-signage-industry-initialized') === 'true') {
      return;
    }

    var wrap = root.querySelector('[data-si-carousel]');
    if (!wrap || typeof window.EmblaCarousel !== 'function') {
      return;
    }

    var viewport = wrap.querySelector('.si-embla__viewport');
    var prevBtn = wrap.querySelector('[data-si-prev]');
    var nextBtn = wrap.querySelector('[data-si-next]');
    var dotsNode = wrap.querySelector('[data-si-dots]');
    var slides = wrap.querySelectorAll('.si-embla__slide');
    if (!viewport || slides.length === 0) {
      root.setAttribute('data-signage-industry-initialized', 'true');
      return;
    }

    var api = window.EmblaCarousel(viewport, { loop: slides.length > 1 });
    root._siEmblaApi = api;

    function togglePrevNext() {
      if (!prevBtn || !nextBtn) return;
      var canPrev = api.canScrollPrev();
      var canNext = api.canScrollNext();
      prevBtn.disabled = !canPrev;
      nextBtn.disabled = !canNext;
      prevBtn.classList.toggle('si-embla__btn--disabled', !canPrev);
      nextBtn.classList.toggle('si-embla__btn--disabled', !canNext);
    }

    var dotNodes = [];
    function renderDots() {
      if (!dotsNode) return;
      dotsNode.innerHTML = api
        .scrollSnapList()
        .map(function () {
          return '<button type="button" class="si-embla__dot" role="tab"></button>';
        })
        .join('');
      dotNodes = Array.prototype.slice.call(dotsNode.querySelectorAll('.si-embla__dot'));
      dotNodes.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          api.scrollTo(i);
        });
      });
      updateDots();
    }

    function updateDots() {
      var selected = api.selectedScrollSnap();
      dotNodes.forEach(function (dot, i) {
        dot.classList.toggle('si-embla__dot--selected', i === selected);
        dot.classList.toggle('is-selected', i === selected);
      });
    }

    function onSelect() {
      togglePrevNext();
      updateDots();
      setActiveIndex(root, api.selectedScrollSnap());
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        api.scrollPrev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        api.scrollNext();
      });
    }

    var gridHandlers = [];
    root.querySelectorAll('[data-si-grid-index]').forEach(function (cell) {
      var handler = function () {
        var idx = parseInt(cell.getAttribute('data-si-grid-index'), 10);
        if (!isNaN(idx)) api.scrollTo(idx);
      };
      cell.addEventListener('click', handler);
      gridHandlers.push({ cell: cell, handler: handler });
    });

    root._siGridClickCleanup = function () {
      gridHandlers.forEach(function (g) {
        g.cell.removeEventListener('click', g.handler);
      });
    };

    api.on('select', onSelect);
    api.on('reinit', togglePrevNext);
    api.on('reinit', renderDots);
    api.on('reinit', onSelect);

    renderDots();
    onSelect();

    root.setAttribute('data-signage-industry-initialized', 'true');
  }

  function runInitForRoot(root) {
    destroy(root);
    init(root);
  }

  function waitEmbla(cb) {
    if (typeof window.EmblaCarousel === 'function') {
      cb();
      return;
    }
    var n = 0;
    var t = setInterval(function () {
      n += 1;
      if (typeof window.EmblaCarousel === 'function') {
        clearInterval(t);
        cb();
      } else if (n > 80) {
        clearInterval(t);
      }
    }, 50);
  }

  document.addEventListener('DOMContentLoaded', function () {
    waitEmbla(function () {
      document.querySelectorAll('[data-signage-industry]').forEach(init);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    waitEmbla(function () {
      target.querySelectorAll('[data-signage-industry]').forEach(runInitForRoot);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    target.querySelectorAll('[data-signage-industry]').forEach(destroy);
  });
})();
